module.exports = __webpack_public_path__ + "images/emoji/fuelpump.d74ea9d9afce240b236d.png";